module.exports = new __parcel__URL__("DarkError.d13c9c5b.png").toString();